module.exports = __webpack_public_path__ + "media/images/top/howto-05-b55a9194647a6a0e57dd236064509518.svg";